module.exports = __webpack_public_path__ + "img/fleece.c39d880e.svg";